import { ACCENTS } from "./accents";
import type { AccentName } from "./accents";
import { blackTheme, darkTheme, lightTheme } from "./themes";
import type { Theme } from "./themes";

/** The base of a theme: light, dark, or black, which is dark with a black background for dark stages. */
export type ThemeBase = "light" | "dark" | "black";

/** What colour the chords are: the accent's, the lyrics' own, or another accent colour. */
export type ChordColor = "accent" | "text" | AccentName;

/** The colours of the app, made from the choices in the appearance settings. */
export function buildTheme(base: ThemeBase, accent: AccentName, chords: ChordColor): Theme {
    const shade = base === "light" ? "light" : "dark";
    const colors = ACCENTS[accent][shade];
    const theme = { ...{ light: lightTheme, dark: darkTheme, black: blackTheme }[base], ...colors };

    if (chords === "text") theme.chord = theme.text;
    else if (chords !== "accent") theme.chord = ACCENTS[chords][shade].chord;

    return theme;
}
